// extracted by mini-css-extract-plugin
module.exports = {"button":"BtnOptionSelect_button__BcV5v","active":"BtnOptionSelect_active__2P5Kt"};